import { FC } from 'react';

import { useSelector } from 'src/modules/useSelector';

import MenuGroup from 'src/components/Menu/MenuGroup';
import MenuLink from 'src/components/Menu/MenuLink';
import { MenuItemWithSubItems, MenuItemWithUrl } from 'src/components/Menu/utils';

import styles from 'src/components/Menu/menu.less';

const Menu: FC = () => {
    const menu = useSelector(({ menu }) => menu);

    return (
        <nav className={styles.menu}>
            <ul className={styles.menuList}>
                {menu.map((itemLevel1, index) => {
                    if (itemLevel1.items) {
                        return (
                            <li key={index} className={styles.menuItem} data-qa="menu-item">
                                <MenuGroup {...(itemLevel1 as MenuItemWithSubItems)} />
                            </li>
                        );
                    }
                    return (
                        <li key={index} className={styles.menuItem} data-qa="menu-item">
                            <MenuLink {...(itemLevel1 as MenuItemWithUrl)} />
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};

export default Menu;
